import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPotion = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M28.873 23.451C27.7998 22.2058 26.3226 21.378 24.7003 21.1127C23.0779 20.8474 21.414 21.1615 20 22C18.5861 22.8385 16.9221 23.1527 15.2998 22.8874C13.6774 22.6221 12.2002 21.7942 11.127 20.549",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 9H25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 9V13.523C14.9984 14.2307 13.3114 15.6232 12.2371 17.4544C11.1629 19.2857 10.7706 21.4377 11.1296 23.5302C11.4886 25.6227 12.5758 27.5209 14.199 28.8893C15.8222 30.2577 17.877 31.0083 20 31.0083C22.1231 31.0083 24.1778 30.2577 25.801 28.8893C27.4242 27.5209 28.5114 25.6227 28.8704 23.5302C29.2294 21.4377 28.8371 19.2857 27.7629 17.4544C26.6887 15.6232 25.0017 14.2307 23 13.523V9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5 20C18.3284 20 19 19.3284 19 18.5C19 17.6716 18.3284 17 17.5 17C16.6716 17 16 17.6716 16 18.5C16 19.3284 16.6716 20 17.5 20Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgPotion);
export default ForwardRef;
